@if (errorMessage) {
  <tidy-error-message
    [text]="errorMessage" />
}

@if (windowService.isDesktopRes) {
  <tidy-desktop-header>
    <div class="wrappable-container allow-wrap">
      <tidy-text
        [title]="'Receivables'" />
      <tidy-text
        [helper]="'Revenue per reservation — booking payments, cleaning fees, and add-ons. The receivables agent runs when payments are overdue.'" />
    </div>
    <div class="non-wrappable-right-aligned-container">
    </div>
  </tidy-desktop-header>
  <!-- Skeleton table while loading — rows float in with the entrance cascade;
       the real table below then replaces it in place, instantly (skipEntrance). -->
  @if (!isDataLoaded) {
    <tidy-table
      [skeletonLoading]="true"
      [columnslabels]="headers" />
  }
  @if (isDataLoaded && rows.length > 0) {
    <div class="desktop-flex-fill">
      <tidy-table
        #tidyTable
        [dataSource]="rows"
        [displayedColumns]="headers"
        [columnslabels]="headers"
        [allRowIsClickable]="true"
        [rowsToShow]="25"
        [showColumnLines]="false"
        [skipEntrance]="true"
        (sortChange)="sortChanged($event)"
        (cellClick)="onTableColumnClick($event)"
        [blockSorting]="true" />
    </div>
  }
  @if (isDataLoaded && rows.length === 0) {
    <tidy-alert>
      <tidy-row>
        <tidy-text [body]="getEmptyStateMessage()" />
      </tidy-row>
    </tidy-alert>
  }
}

@if (!windowService.isDesktopRes) {
  @if (!isDataLoaded) {
    <div style="width: 100%">
      <ion-skeleton-text
        animated="true"
        style="height: 75px; border-radius: 6px" />
    </div>
    <div style="width: 100%; padding-top: 1rem;">
      <ion-skeleton-text
        animated="true"
        style="height: 200px; border-radius: 6px" />
    </div>
  }
  @if (isDataLoaded) {
    @for (receivable of receivables; track receivable.id) {
      <tidy-card>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text
            [header]="receivable.property_name || 'Unknown Property'"
            [translate]="false" />
          <tidy-text
            [helper]="receivable.status"
            [translate]="false" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-text
            [body]="receivable.guest_name + ' — ' + receivable.reservation_dates"
            [translate]="false" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-text
            [helper]="receivable.description"
            [translate]="false" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-grid>
            <ion-row>
              <ion-col size="4">
                <tidy-row>
                  <tidy-text [helper]="'Due'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'$' + receivable.amount_due?.toLocaleString('en-US')"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
              <ion-col size="4">
                <tidy-row>
                  <tidy-text [helper]="'Paid'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'$' + receivable.amount_paid?.toLocaleString('en-US')"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
              <ion-col size="4">
                <tidy-row>
                  <tidy-text [helper]="'Channel'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="receivable.channel"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-row>
      </tidy-card>
    }
    @if (receivables.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="getEmptyStateMessage()" />
        </tidy-row>
      </tidy-alert>
    }
  }
}
